import { FC, ReactNode } from "react";

import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useEffectOnceWhen } from "rooks";
import { executionLogSourceAndExecutedByFilterKey } from "../../../../utils/constants/common";
import { getSourceAndExecutedByFromSelectValues } from "../../../../utils/helpers/getSourceAndExecutedByFromSelectValues";
import { DropdownSelectOption } from "@/components/common/select/dropdown-select/utils/types/types";
import { getExecutionLogSourceFilterOption } from "@/components/pages/execution-log/components/header/filters/source-filter/getExecutionLogSourceFilterOption";

interface ExecutionLogSourceFilterHOCProps {
  children: ReactNode;
  onFilterAdd(values: string[]): void;
  options: DropdownSelectOption[];
  setOptions(options: DropdownSelectOption[]): void;
}

export const ExecutionLogSourceFilterHOC: FC<
  ExecutionLogSourceFilterHOCProps
> = ({ onFilterAdd, setOptions, children, options }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const urlSourceFilter = searchParams.get(
    executionLogSourceAndExecutedByFilterKey,
  ) as string;

  useEffectOnceWhen(() => {
    if (!urlSourceFilter) {
      return;
    }

    onFilterAdd([urlSourceFilter]);

    const hasSuchOption = options.some(
      (option) => option.value === urlSourceFilter,
    );

    if (!hasSuchOption) {
      const { source, executedBy } = getSourceAndExecutedByFromSelectValues([
        urlSourceFilter,
      ]);

      setOptions([
        ...options,
        getExecutionLogSourceFilterOption(
          executedBy?.at(0),
          source?.at(0),
          urlSourceFilter,
        ),
      ]);
    }

    searchParams.delete(executionLogSourceAndExecutedByFilterKey);

    navigate({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  }, !!urlSourceFilter && !!options.length);

  return children;
};
